import React, { useId, useMemo } from 'react';

/** Gold rectangular badge (no ribbons). Width scales with label length. */
export const LegalQuickRibbonBadge: React.FC<{ label: string }> = ({ label }) => {
  const uid = useId().replace(/:/g, '');
  const goldMedalId = `legalRibbonGoldMedal-${uid}`;

  const text = label.trim().toUpperCase();
  const chars = Math.max(1, text.length);

  const { vbW, fontSize } = useMemo(() => {
    const width = Math.min(140, Math.max(44, Math.round(18 + chars * 5.8)));
    const size = Math.min(8.5, Math.max(5.5, (width - 16) / (chars * 0.64)));
    return { vbW: width, fontSize: size };
  }, [chars]);

  const mid = vbW / 2;
  const innerW = vbW - 2;
  const innerW2 = vbW - 4;

  return (
    <span
      className="legal-quick-ribbon-badge"
      role="img"
      aria-label={text}
      style={{ '--badge-chars': String(chars) } as React.CSSProperties}
    >
      <svg viewBox={`0 0 ${vbW} 24`} fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
        <defs>
          <linearGradient id={goldMedalId} x1={mid} y1="2" x2={mid} y2="22" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FFE9A8" />
            <stop offset="0.45" stopColor="#F5C542" />
            <stop offset="1" stopColor="#C98A12" />
          </linearGradient>
        </defs>
        <rect x="1" y="1" width={innerW} height="22" rx="5" fill="#A87410" />
        <rect x="2" y="2" width={innerW2} height="20" rx="4.5" fill={`url(#${goldMedalId})`} />
        <rect
          x="3.5"
          y="3.5"
          width={innerW2 - 3}
          height="17"
          rx="3.5"
          fill="none"
          stroke="#FFF2C2"
          strokeWidth="0.9"
          opacity="0.9"
        />
        <text
          x={mid}
          y="12.5"
          textAnchor="middle"
          dominantBaseline="middle"
          fill="#7A4E00"
          fontSize={fontSize}
          fontWeight="800"
          fontFamily="var(--catalog-font, 'Plus Jakarta Sans', system-ui, sans-serif)"
          letterSpacing="0.06em"
        >
          {text}
        </text>
      </svg>
    </span>
  );
};
